import {ActionType} from '../actionTypes';
import {Action} from '../actions';

interface RepositoriesState{
    loading:boolean;
    error: string | null;
    data: Array<{
        id: number;
        category: string;
        time_in: string;
        nominations: null | any; // Adjust the type based on your actual data structure
        CreatedAt: string;
        UpdatedAt: string;
      }>;
}


// interface Action {
//     type: string;
//     payload?: any;// the ? means may or may not have
// }

const initailState = {
    loading:false,
    error:null,
    data: [],

};
const reducer = (
    state:RepositoriesState = initailState,
    action: Action
 
    ): RepositoriesState => { // the return type will always be of the type RepositoriesState (annotation)

    switch (action.type){
        case ActionType.SEARCH_REPOSITORIES:
            return {loading:true, error:null, data:[]};
        
        case ActionType.SEARCH_REPOSITORIES_SUCCESS:
            return {loading:false, error:null, data:action.payload};
        case ActionType.SEARCH_REPOSITORIES_ERROR:
            return {loading:false, error:action.payload, data:[]};
        default:
            return state;
    }

};

export default reducer;